const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Lalit Kumar | Portfolio",
  description:
    "A Data Science practitioner who thrives to leverage startups with AI based solutions with a blend of UI/UX",
  og: {
    title: "Lalit Portfolio",
    type: "website",
    url: "http://lalitkumar.ml/",
  },
};

//Home Page
const greeting = {
  title: "Namaste!",
  sub: "Lalit Kumar",
  logo_name: "Lalit Kumar",
  resumeLink:
    "https://www.canva.com/design/DAGYK2-dC3E/R13khw8VBMjtQwU2eohZ-Q/view?utm_content=DAGYK2-dC3E&utm_campaign=designshare&utm_medium=link&utm_source=editor",
};

// home logos
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LinkedIn",
      iconifyClassname: "simple-icons:linkedin",
      style: {
        color: "#0077b5",
      },
      profileLink: "https://www.linkedin.com/in/dev-lalitkumar/",
    },
    {
      siteName: "Freelancer",
      iconifyClassname: "simple-icons:freelancer",
      style: {
        color: "#29B2FE",
      },
      profileLink: "https://www.freelancer.com/u/adrashyawarrior",
    },
    {
      siteName: "Github",
      iconifyClassname: "simple-icons:github",
      style: {
        color: "white",
      },
      profileLink: "https://github.com/dev-lalitkumar",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/AdrashyaWarrior",
    },
    {
      siteName: "Stack Overflow",
      iconifyClassname: "simple-icons:stackoverflow",
      style: {
        color: "#F58025",
      },
      profileLink:
        "https://stackoverflow.com/users/13892391/lalit-kumar?tab=profile",
    },
    {
      siteName: "Twitter",
      iconifyClassname: "simple-icons:twitter",
      style: {
        color: "#1D9BF0",
      },
      profileLink: "https://twitter.com/dev_lalitkumar",
    },
    {
      siteName: "Instagram",
      iconifyClassname: "simple-icons:instagram",
      style: {
        color: "#E4405F",
      },
      profileLink: "https://www.instagram.com/meta.lalitkumar/",
    },
  ],
};

//what i do?
const skills = {
  data: [
    {
      title: "Full-Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive websites using HTML5, TailwindCSS, JavaScript, React.jS & Next.js",
        "⚡ Creating backend applications in Node.js, Nest.js & Laravel",
        "⚡ Database designing & handling using MySQL & MongoDB",
      ],
      softwareSkills: [
        {
          skillName: "Next.Js",
          fontAwesomeClassname: "simple-icons:nextdotjs",
          style: {
            color: "#fff",
          },
        },
        {
          skillName: "Nest.js",
          fontAwesomeClassname: "simple-icons:nestjs",
          style: {
            color: "#E0234E",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: {
            backgroundColor: "#000000",
            color: "#3178C6",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:nodedotjs",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
      ],
    },
    {
      title: "Server & Maintenance",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Having experience in Domain & Hosting using Hostinger, GoDaddy, AWS & Netlify",
        "⚡ Configure and maintain web applications using Apache on CentOS & Ubuntu servers",
        "⚡ Deploying Node applications on Netlify & Linux with pm2 configuration",
        "⚡ Managing DNS & implementing SSL certificates",
      ],
      softwareSkills: [
        {
          skillName: "cPanel",
          fontAwesomeClassname: "simple-icons:cpanel",
          style: {
            backgroundColor: "#000",
            color: "#FF6C2C",
          },
        },
        {
          skillName: "Hostinger",
          fontAwesomeClassname: "simple-icons:hetzner",
          style: {
            backgroundColor: "#674CC4",
            color: "#000",
          },
        },
        {
          skillName: "GoDaddy",
          fontAwesomeClassname: "simple-icons:godaddy",
          style: {
            backgroundColor: "transparent",
            color: "#1BDBDB",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            backgroundColor: "transparent",
            color: "#FF9900",
          },
        },
        {
          skillName: "Apache",
          fontAwesomeClassname: "simple-icons:apache",
          style: {
            backgroundColor: "transparent",
            color: "#D22128",
          },
        },
        {
          skillName: "Netlify",
          fontAwesomeClassname: "simple-icons:netlify",
          style: {
            backgroundColor: "transparent",
            color: "#00C7B7",
          },
        },
        {
          skillName: "PM2",
          fontAwesomeClassname: "simple-icons:pm2",
          style: {
            backgroundColor: "transparent",
            color: "#2B037A",
          },
        },
        {
          skillName: "SSL",
          fontAwesomeClassname: "simple-icons:openssl",
          style: {
            backgroundColor: "transparent",
            color: "#721412",
          },
        },
      ],
    },
    {
      title: "New Edge Sulotions",
      fileName: "DesignImg",
      skills: [
        "⚡ Integrating Chat-GPT / Llama3.X with your database so that you can talk to your website like we do.",
        "⚡ Send Bulk/Automated Whatsapp Messages or create a AI powered Whatsapp-Bot for your site.",
        "⚡ Realtime notifications & chats using websockets.",
        "⚡ Get your Facebook & Instagram Leads in your crm automatically.",
      ],
      softwareSkills: [
        {
          skillName: "LangChain",
          fontAwesomeClassname: "simple-icons:langchain",
          style: {
            color: "#a2c221",
          },
        },
        {
          skillName: "Chat-GPT",
          fontAwesomeClassname: "simple-icons:openai",
          style: {
            color: "#18A497",
          },
        },
        {
          skillName: "Meta",
          fontAwesomeClassname: "simple-icons:meta",
          style: {
            color: "#0866FF",
          },
        },
        {
          skillName: "OLlama",
          fontAwesomeClassname: "simple-icons:ollama",
          style: {
            color: "#FFF",
          },
        },
        {
          skillName: "Pinecone",
          fontAwesomeClassname: "logos:pinecone-icon",
          style: {
            color: "#000",
          },
        },
        {
          skillName: "Whatsapp",
          fontAwesomeClassname: "simple-icons:whatsapp",
          style: {
            color: "#25D366",
          },
        },
        {
          skillName: "WebSockets",
          fontAwesomeClassname: "simple-icons:socketdotio",
          style: {
            backgroundColor: "#010101",
          },
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create CRM projects.",
};

//project cards
// colors:[primary,secondary,success,danger,warning,info,light,dark,]
const projectcards = {
  list: [
    {
      title: "WHSuites 2.0",
      subtitle: "Lead Management Software",
      img_path: "whsuites2.png",
      description:
        "Working on features like automated mails & whatsapp messsages along with campaigns, automated Facebook & Instagram & Google Business Leads, Payment Gateway, IP Restrictions etc.",
      link: "https://www.whsuites.com/",
      linkcolor: "white",
      technology: "Next.js, Nest.js, TypeORM, MySQL",
      role: "Backend Developer",
      copyright: "Webhopers Infotech Pvt Ltd, Chandigarh",
    },
    {
      title: "WHSuites",
      subtitle: "Lead Management Software",
      img_path: "whsuites.png",
      description:
        "As a team member, I worked on features addition like automated Facebook Leads, Management & fixes.",
      link: "https://www.whsuites.com/",
      linkcolor: "white",
      technology: "Laravel, Blade, JQuery, Bootstrap, MySQL",
      role: "Full-Stack Developer",
      copyright: "Webhopers Infotech Pvt Ltd, Chandigarh",
    },
    {
      title: "MP2IT CRM",
      subtitle: "Customer Relationship Management Software",
      img_path: "wrirk-crm.png",
      description:
        "Database designing, Stripe & Razorpay Integration, Transaction Management, Employees Incentive tracking along with projects & leads.",
      link: "https://www.whsuites.com/",
      linkcolor: "white",
      technology: "Laravel, Rest APIs, MySQL",
      role: "Backend Developer",
      copyright: "MP2IT Pvt Ltd, Mathura",
    },
    {
      title: "Blackstones Spa",
      subtitle: "Multivendor Inventory Management",
      img_path: "blackstone.png",
      description: "Qoyod Integration, features addition & fixes etc.",
      link: "https://www.whsuites.com/",
      linkcolor: "white",
      technology: "Laravel, Blade, JQuery, Bootstrap, MySQL",
      role: "Full-Stack Developer",
      copyright: "Webhopers Infotech Pvt Ltd, Chandigarh",
    },
    {
      title: "Wrirk",
      subtitle: "Academic Reaserch Services Repo Management",
      img_path: "wrirk.png",
      description:
        "I indivisually built the Admin Dashbord from scratch including database designing. And for website built Rest-APIs.",
      link: "https://www.whsuites.com/",
      linkcolor: "white",
      technology: "Laravel, Livewire, TailwindCSS, Apline.js, MySQL",
      role: "Full-Stack Developer",
      copyright: "MP2IT Pvt Ltd, Mathura",
    },
    {
      title: "Learn Gita Live Gita",
      subtitle: "ISKCON established, spiritual education and Vedic culture",
      img_path: "learngita.png",
      description:
        "Laravel Upgrade from 6 to 10, Razorpay & CCAvanue Integration.",
      link: "https://www.whsuites.com/",
      linkcolor: "white",
      technology: "Laravel, Blade, JQuery, Bootstrap, MySQL",
      role: "Full-Stack Developer",
      copyright: "Webhopers Infotech Pvt Ltd, Chandigarh",
    },
    {
      title: "BrandSpring",
      subtitle: "Marketing Service Provider In Rural & Urban India",
      img_path: "brandspring.png",
      description: "Renewed the website with more features addition & fixes.",
      link: "https://www.whsuites.com/",
      linkcolor: "white",
      technology: "Laravel, Blade, JQuery, Bootstrap, MySQL",
      role: "Full-Stack Developer",
      copyright: "Smart Digital Traffic Analysis Pvt Ltd, Noida",
    },
    {
      title: "Butterfly Psychology",
      subtitle: "Psychological Services For Kids In Australia",
      img_path: "butterfly.png",
      description:
        "From Scratch I turned the HTML-CSS files into Blade files & built the backend.",
      link: "https://www.whsuites.com/",
      linkcolor: "white",
      technology: "Laravel, Blade, JQuery, Bootstrap, MySQL",
      role: "Full-Stack Developer",
      copyright: "Smart Digital Traffic Analysis Pvt Ltd, Noida",
    },
    {
      title: "Adrashya SMS",
      subtitle: "Multi Providers SMS Node Package",
      img_path: "adrashya-sms.png",
      description:
        "I Indivisually developed this for sending, priority based multi SMS-Gateways supported, marketing & transactional text messages along with DLT approved templates support.",
      link: "https://www.whsuites.com/",
      linkcolor: "white",
      technology: "Node.js, Javascript",
      role: "Full-Stack Developer",
      copyright: "Webhopers Infotech Pvt Ltd, Chandigarh",
    },
  ],
};

const startDate = new Date("2022-07-01");
const currentDate = new Date();
const diffInMonths =
  (currentDate.getFullYear() - startDate.getFullYear()) * 12 +
  (currentDate.getMonth() - startDate.getMonth());
const years = Math.floor(diffInMonths / 12);
const months = diffInMonths % 12;
const currentExp = `${years} Years ${months} Months - Present`;

const resumeleft = {
  left: {
    title: ["Experience"],
    data: [
      {
        title: "MERN Full-Stack Developer",
        subtitle: "Webhopers Infotech Pvt Ltd, Mohali ( India )",
        date: `${currentExp}`,
        content: [
          "Leading SAAS - CRM(WHSuites) in MERN",
          "Maintaining & Upgrading Express.js sites to Nest.js",
          "Integrated a range of third party APIs",
        ],
      },
      {
        title: "Node.js Developer",
        subtitle: "MP2IT Pvt Ltd, Mathura ( India )",
        date: "1 Year 2+ Months",
        content: [
          "Built CRM, Attendance Monitoring System For company's employees",
          "Wrirk( Research Work Repo Management ) - Built a new product for Company ",
        ],
      },
      {
        title: "MERN Intern",
        subtitle: "Smart Digital Traffic Analysis, Noida ( India )",
        date: "6+ Months",
        content: ["Web Application concepts along with MERN Stack"],
      },
    ],
  },
};

const resumeright = {
  right: [
    {
      title: ["Education"],
      data: [
        {
          title: "B.Tech Hons. (Computer Science & Engineering)",
          subtitle: "APJ Abdul Kalam Technical University, Lucknow ( India )",
          date: "2016 - 2020",
          content: ["CGPA: 8.3/10"],
        },
        {
          title: "Higher Secondary Certificate [HSC]",
          subtitle: "Th. Biri Singh Inter College, Tundla (India)",
          date: "2014 - 2016",
          content: ["Precentage: 87.20%"],
        },
        {
          title: "Secondary School Certificate [SSC]",
          subtitle: "Sharda Raman H. S. School, Tundla (India)",
          date: "2012 - 2014",
          content: ["Precentage: 82.33%"],
        },
      ],
    },
    // {
    //   title: ["Ranks and Achivements"],
    //   data: [
    //     {
    //       title: "Ranks",
    //       content: [
    //         "#135/854 in Summer Analytics Kaggle Competition by IITG",
    //         "#113/5064 in CV-NLP Hackathon by HackerEarth",
    //       ],
    //     },
    //     {
    //       title: "Achievements",
    //       content: [
    //         "Designing Team Head at ACM-VIT",
    //         "5⭐ Gold Badges for Python & Problem Solving at HackerRank ",
    //         "Tableau Analyst & Consumer Badge by Tableau Official",
    //       ],
    //     },
    //   ],
    // },
    {
      title: ["Freelance Work"],
      data: [
        {
          title: "Freelancer.com",
          subtitle: "5.0 ⭐ (14 Reviews)",
          content: [
            "Payment Gateway Integration, Admin Dashboard, CLI & Problem Solving Projects etc.",
          ],
        },
        // {
        //   title: "Medical Consultation Website",
        //   subtitle: "http://www.medilinksindia.com/",
        //   content: [
        //     "Built a website for a reputed mediacal consultancy in india",
        //   ],
        // },
      ],
    },
  ],
};

//certificate cards
const certifications = {
  certifications: [
    // {
    //   title: "Tableau Analyst",
    //   subtitle: "Tableau",
    //   logo_path: "tabana-01.png",
    //   certificate_link:
    //     "https://www.credly.com/badges/2d43f401-7be0-407d-9a77-7477dda8cade/linked_in_profile",
    //   alt_name: "Tableau",
    //   color_code: "#000000",
    // },
    // {
    //   title: "Tableau Consumer",
    //   subtitle: "Tableau",
    //   logo_path: "tabcon-01.png",
    //   certificate_link:
    //     "https://www.credly.com/badges/e5befe7b-2eec-486f-b77e-bd2458c18b26/linked_in_profile",
    //   alt_name: "Tableau",
    //   color_code: "#000000",
    // },
    {
      title: "Java",
      subtitle: "HackerRank",
      logo_path: "java.png",
      certificate_link: "https://www.hackerrank.com/AdrashyaWarrior",
      alt_name: "HackerRank",
      color_code: "#000000",
    },
    {
      title: "C",
      subtitle: "HackerRank",
      logo_path: "c.png",
      certificate_link: "https://www.hackerrank.com/AdrashyaWarrior",
      alt_name: "HackerRank",
      color_code: "#000000",
    },

    {
      title: "Python",
      subtitle: "HackerRank",
      logo_path: "python.png",
      certificate_link: "https://www.hackerrank.com/AdrashyaWarrior",
      alt_name: "HackerRank",
      color_code: "#000000",
    },
    {
      title: "JavaScript",
      subtitle: "HackerRank",
      logo_path: "js.png",
      certificate_link: "https://www.hackerrank.com/AdrashyaWarrior",
      alt_name: "HackerRank",
      color_code: "#000000",
    },
    {
      title: "Silver Badges (1)",
      subtitle: "StackOverflow",
      logo_path: "silver.png",
      certificate_link:
        "https://stackoverflow.com/users/13892391/lalit-kumar?tab=profile",
      alt_name: "StackOverflow",
      color_code: "#000000",
    },
    {
      title: "Bronze Badges (4)",
      subtitle: "StackOverflow",
      logo_path: "bronze.png",
      certificate_link:
        "https://stackoverflow.com/users/13892391/lalit-kumar?tab=profile",
      alt_name: "StackOverflow",
      color_code: "#000000",
    },
    // {
    //   title: "Certificate of Merit",
    //   subtitle: "Summer Analytics | IIT Guwahati",
    //   logo_path: "iitg-01.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
    //   alt_name: "IITG",
    //   color_code: "#000000",
    // },
    // {
    //   title: "Tableau Desktop Qualified Associate",
    //   subtitle: "SimpliLearn",
    //   logo_path: "simplilearn-01.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
    //   alt_name: "Simplilearn",
    //   color_code: "#000000",
    // },
    // {
    //   title: "Question Generation using Transformers",
    //   subtitle: "Udemy",
    //   logo_path: "udemy-01.png",
    //   certificate_link:
    //     "https://www.udemy.com/certificate/UC-b17c4c21-91e3-4f8b-b9c2-259468910985/",
    //   alt_name: "Udemy",
    //   color_code: "#000000",
    // },
    // {
    //   title: "Machine Learning",
    //   subtitle: "Stanford University",
    //   logo_path: "coursera-01.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
    //   alt_name: "Stanford University",
    //   color_code: "#000000",
    // },
    // {
    //   title: "Data Visualization",
    //   subtitle: "University of Michigan",
    //   logo_path: "coursera-01.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
    //   alt_name: "University of Michigan",
    //   color_code: "#000000",
    // },
    // {
    //   title: "Data Scientist Career Track",
    //   subtitle: "DataCamp",
    //   logo_path: "datacamp-01.png",
    //   certificate_link:
    //     "https://www.datacamp.com/statement-of-accomplishment/track/29f2ddab3fbfd0a470713a19c729c0f9d89c88aa",
    //   alt_name: "DataCamp",
    //   color_code: "#000000",
    // },
    // {
    //   title: "PowerBI Masters",
    //   subtitle: "iNeuron.ai",
    //   logo_path: "ineuron-01.png",
    //   certificate_link:
    //     "https://academy.ineuron.ai/certificates/downloads/PB009929.pdf",
    //   alt_name: "HackerRank",
    //   color_code: "#000000",
    // },
    // {
    //   title: "Tableau Masters",
    //   subtitle: "iNeuron.ai",
    //   logo_path: "ineuron-01.png",
    //   certificate_link:
    //     "https://academy.ineuron.ai/certificates/downloads/TB000634.pdf",
    //   alt_name: "HackerRank",
    //   color_code: "#000000",
    // },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "contact.jpg",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with building, deploying & maintaining web applications, also love to contribute to Opensource Projects.",
  },
  addressSection: {
    title: "Current Address",
    line1: "E-25 Panchsheel Enclave, Near Metro City",
    line2: "Zirakpur, Punjab - 140603",
  },
  phoneSection: {
    title: "Contact Details",
    subtitle: "+91-9557758955",
  },
};

//contact icons
const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/dev-lalitkumar",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#919090", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/dev-lalitkumar/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  // {
  //   name: "YouTube",
  //   link: "https://www.youtube.com/c/rohanalytics",
  //   fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
  //   backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  // },
  {
    name: "Gmail",
    link: "mailto:mailatlalitkumar@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/lalitkumar.socialmedia/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
  {
    name: "Twitter",
    link: "https://twitter.com/dev_lalitkumar",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=instagram
  },
];

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  projectsHeader,
  contactPageData,
  projectcards,
  certifications,
  resumeleft,
  resumeright,
};
